import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * FilterTagsView class extends JetView to create a filter interface for tags.
 */
export default class FilterTagsView extends JetView {
    /**
     * Configures the UI components of the FilterTagsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section configuration with input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for ID
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            label: "<span class='icon-file-text1'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'richselect', // Dropdown for Type selection
                            name: 'Type',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Casino') },
                                { id: '2', value: _('LiveCasino') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Second left section configuration with additional input fields
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Slug
                            name: 'Slug',
                            label: _('Slug'),
                            labelPosition: 'top',
                            placeholder: _('Slug'),
                            invalidMessage: _('Slug is required'), // Validation message
                        },
                        {
                            view: 'richselect', // Dropdown for IsActivate selection
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Text input for Higher
                            name: 'Higher',
                            label: "<span class='icon-arrow-up'></span>" + _('Superior'),
                            labelPosition: 'top',
                            placeholder: _('Superior'),
                        },
                    ],
                },
            ],
        };

        // Upper section configuration containing the first left section
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section configuration containing the second left section
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Buttons configuration for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to add a tag
                            value: _('Añadir Etiqueta'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction('tagsAdd', 'Add'), // Permission check
                            css: 'prm-tagsAdd',
                            click: () => {
                                this.app.callEvent('addTags:button', [[]]); // Event call on click
                            },
                        },
                        {
                            view: 'button', // Button to clear inputs
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter tags
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('tags:filter', [filterdata]); // Event call with filter data
                                $$('b1').collapse(); // Collapse accordion
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section configuration for filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Body contains upper sections and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
